import { createContext } from "../../utils/createContext";

import type { AccordionClassNames, AccordionSlots } from "./accordionVariants";

export interface AccordionContext {
  slots: AccordionSlots;
  classNames?: AccordionClassNames;
}

export const [AccordionProvider, useAccordionContext] = createContext<AccordionContext>({
  name: "AccordionContext",
});
